/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDownloadReponse } from '../../models/dashboard-download-reponse';
import { DashboardSearchModel } from '../../models/dashboard-search-model';

export interface DashboardDashboardDownloadPost$Json$Params {
      body?: DashboardSearchModel
}

export function dashboardDashboardDownloadPost$Json(http: HttpClient, rootUrl: string, params?: DashboardDashboardDownloadPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardDownloadReponse>> {
  const rb = new RequestBuilder(rootUrl, dashboardDashboardDownloadPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<DashboardDownloadReponse>;
    })
  );
}

dashboardDashboardDownloadPost$Json.PATH = '/Dashboard/DashboardDownload';
